import { z } from "zod";

// Request body for minting a Personal Access Token (PAT). The raw token is
// returned exactly once in the create response and never again.
export const tokenCreateSchema = z.object({
  name: z.string().trim().min(1).max(80),
  // Optional lifetime; the API defaults to 90 days when omitted.
  expiresInDays: z.number().int().positive().max(365).optional(),
});
export type TokenCreateInput = z.infer<typeof tokenCreateSchema>;

// Safe representation of a token row — never includes the hash or raw secret.
export type PatRowDTO = {
  id: string;
  name: string;
  tokenPrefix: string;
  scopes: string[];
  lastUsedAt: string | null;
  expiresAt: string | null;
  revokedAt: string | null;
  createdAt: string;
};

// Returned only at creation time: the safe row plus the one-time raw token.
export type PatCreateResponseDTO = {
  row: PatRowDTO;
  token: string;
};
